import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import AugmentoIcon from "./SVGComponents/AugmentoIcon";
import { t } from "i18next";
import WidgetSelectStyles from './WidgetSelectStyles';
import DownArrowIcon from './DownArrowIcon';
import OpenInNewIcon from './OpenInNewIcon';
import OpenWidgetHeader from './OpenWidgetHeader';
import { API_BASE_URL } from '../../constants/Constants';
import { getEnv } from '../../helpers/EnvHelper';
// import "./style.css";

const columnFilterStyles = {
  control: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    backgroundColor: '#0C1A2C',
    borderRadius: '3px',
    border: '1px solid #C4C4C4',
    minHeight: '20px',
    height: '20px',
    width: '60px',
    fontSize: '9px',
    fontWeight: '400',
    padding: 0,
    margin: 0,
  }),
  valueContainer: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '9px',
    fontWeight: '400',
    padding: 0,
    margin: 0,
    overflow: 'hidden',
    // maxWidth: '38px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginLeft: '4px',
    maxWidth: 'calc(100% - 20px)',
    height: '100%'
  }),
  singleValue: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    fontSize: '9px',
    fontWeight: '400',
    margin: 0,
    padding: 0,
    maxWidth: '38px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#F5F5F5',
    // width: '100%',
    lineHeight: 'normal',
  }),
  placeholder: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    color: '#c4c4c4',
    fontSize: '9px',
    fontWeight: '400',
    margin: 0,
    padding: 0,
    maxWidth: '36px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    padding: '0',
    marginRight: '4px'
  }),
  option: (base, state) => ({
    ...base,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: state.isFocused ? '#C4C4C4' : '#0C1A2C',
    color: state.isFocused ? '#040811' : '#fff',
    fontWeight: 400,
    // backgroundColor: state.isFocused ? '#252d48' : '#0C1A2C',
    // color: '#c4c4c4',
    fontSize: '9px',
    padding: '2px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: '#040811',
    borderRadius: '4px',
    marginTop: 2,
    border: '1px solid #ffffff', // ✅ white border around the entire dropdown
    boxShadow: 'none', // optional: remove react-select default shadow
    zIndex: 100000
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: '#F5F5F5',
    borderRadius: '8px',
    padding: 1,
    overflowY: 'auto',
    maxHeight: '150px', // 👈 set desired max height here
    zIndex: 100000,
    /* Scrollbar Styling */
    '::-webkit-scrollbar': {
      width: '6px',
    },
    '::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: '#999',
      borderRadius: '3px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#555',
    },
  }),
};

const columnDropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L4 4L7 0.999999" stroke="#C4C4C4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </components.DropdownIndicator>
);

const formatColumnOptionLabel = ({ label }) => (
  <div
    title={label} // Tooltip on hover
    style={{
      display: 'flex',
      alignItems: 'center',
      // color: '#c4c4c4',
      fontSize: '9px',
      // fontWeight: '400',
      margin: 0,
      padding: 0,
      maxWidth: '36px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    }}
  >
    {label}
  </div>
);



const RAIPerformanceResults = ({ data, findings, studyId, firmId, userName, setShowRAIPanel, setErrorMessage }) => {

  const [findingsFilterOptions, setFindingsFilterOptions] = useState([]);
  const [selectedFinding, setSelectedFinding] = useState('');
  const [organ, setOrgan] = useState('');
  const [modality, setModality] = useState('');
  const [filters, setFilters] = useState({
    manufacturer: [],
    age: [],
    gender: [],
  });
  const [selectedFilters, setSelectedFilters] = useState({
    manufacturer: '',  // or null if you prefer
    age: '',
    gender: '',
  });
  const [filterChangeStatus, setFilterChangeStatus] = useState({
    manufacturer: false,
    age: false,
    gender: false
  });

  const noFilterChange = {
    manufacturer: false,
    age: false,
    gender: false
  };

  const [performanceMatrix, setPerformanceMatrix] = useState({
    sensitivity: { overall: '', manufacturer: '', age: '', gender: '' },
    specificity: { overall: '', manufacturer: '', age: '', gender: '' },
    auroc: { overall: '', manufacturer: '', age: '', gender: '' },
    precision: { overall: '', manufacturer: '', age: '', gender: '' },

  });


  const handleOpenRAIWindow1 = async (studyId, firmId, userName, isReportClicked, isAugDemo, isProductivityClicked, isRaiClicked, chartMode) => {
    try {
      let response = null;
      if (isAugDemo) {
        response = await fetch(`https://augmento-demo.deeptek.ai:8002/gizmo/generate-access-code`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ studyId, firmId, isReportClicked, isProductivityClicked, chartMode }),
        });
      }
      else {
        response = await fetch(`${API_BASE_URL}jwtServices/gizmo/generate-access-code`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify({ studyId, firmId, isReportClicked, isProductivityClicked, chartMode, isRaiClicked }),
        });
      }


      if (!response.ok) {
        const error = await response.text();
        console.error("Failed to generate access code:", error);
        alert("Unable to open viewer.");
        return;
      }

      const data = await response.json();
      const accessCode = data.accessCode;
      let viewerUrl = null;
      if (isAugDemo) {
        viewerUrl = `https://augmento-demo.deeptek.ai/gizmo-viewer?accessCode=${encodeURIComponent(accessCode)}&userName=${encodeURIComponent(userName)}`;
      }
      else {
        const normalizedModality = normalizeModality(modality);   // 👈 you pass modality here
        const normalizedOrgan = normalizeOrgan(organ);  

        const params = new URLSearchParams({
          tab: 0,
          pathologyList: selectedFinding,
          siteList: "CGH",
          vendorList: "Deeptek",

          modalityList: normalizedModality,   // 🔥 now dynamic
          organList: normalizedOrgan,         // 🔥 now dynamic

          accessCode: encodeURIComponent(accessCode),
          userName: encodeURIComponent(userName),
          projectID: "473686",
        });

        // Optional filters
        const ageList = selectedFilters.age ? [selectedFilters.age] : [];
        const genderList = selectedFilters.gender ? [selectedFilters.gender] : [];
        const manufacturerList = selectedFilters.manufacturer ? [selectedFilters.manufacturer] : [];

        ageList.forEach(val => params.append("ageGroupList", val));
        genderList.forEach(val => params.append("genderList", val));
        manufacturerList.forEach(val => params.append("scannerList", val));

        const viewerBaseUrl = `${window.location.origin}/gizmo-viewer`;
        const redirectUrl = `${viewerBaseUrl}?${params.toString()}`;

        console.log("🔗 Redirecting to:", redirectUrl);
        viewerUrl = redirectUrl;
      }

      window.parent.postMessage({ type: "open-external", url: viewerUrl }, "*");
      } catch (err) {
      console.error("Error in handleOpenViewerWindow:", err);
      alert("Something went wrong while opening the viewer.");
    }
  };

  const handleOpenRAIWindow = async () => {
    try {
      const params = new URLSearchParams({
        tab: 0,
        pathologyList: selectedFinding,
        siteList: "CGH",
        vendorList: "Deeptek",
      });
      const ageList = selectedFilters.age === '' ? [] : [selectedFilters.age];
      const genderList = selectedFilters.gender === '' ? [] : [selectedFilters.gender];
      const manufacturerList = selectedFilters.manufacturer === '' ? [] : [selectedFilters.manufacturer];

      ageList?.forEach(val => params.append('ageGroupList', val));
      genderList?.forEach(val => params.append('genderList', val));
      manufacturerList?.forEach(val => params.append('scannerList', val));
      const raiUrl = `${getEnv("REACT_APP_RAI_BASE_URL")}finding-analysis?${params.toString()}`;

      window.parent.postMessage({ type: "open-external", url: raiUrl }, "*");
    } catch (err) {
      console.error("Error in handleOpenRAIWindow:", err);
      alert("Something went wrong while opening the RAI.");
    }
  };

  // const fetchFilterData = async (token) => {
  //   try {

  //     const raiToken = token || localStorage.getItem("raiToken");
  //     const response = await fetch(`${import.meta.env.VITE_RAI_BASE_URL}api/rai-vimhub/unique-values?collection_ID=1`, {
  //       method: "GET",
  //       headers: {
  //         "x-access-token": raiToken,
  //         "Content-Type": "application/json", 
  //       },
  //     });

  //     const result = await response.json();
  //     const findingsFilterOptions = result.models.map(item => ({
  //       label: item,
  //       value: item
  //     }));
  //     setFindingsFilterOptions(findingsFilterOptions);
  //     setFilters(prev => ({
  //         ...prev,
  //         manufacturer: result.scanners,
  //         age: result.ageGroup,
  //         gender: result.gender,
  //       }));
  //     } catch (error) {
  //     console.error("Failed to fetch data", error);
  //   }
  // };

  const fetchFilterData = async (token, retryCount = 0) => {
  try {
    const raiToken = token || localStorage.getItem("raiToken");
    const clientID = localStorage.getItem("raiClientID");

    const params = new URLSearchParams({
      projectID: "473686",
      clientID: "138c4fc9afdadeb856f40b05be06959f",
      prediction: "ai",
    });

    const response = await fetch(
      `${getEnv("REACT_APP_RAI_BASE_URL")}api/rai/filters?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${raiToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();

    // ❌ If API returns success:false → treat as expired token
    if (!result.success) {
      // Stop infinite retry loop
      if (retryCount >= 2) {
        setErrorMessage(result.message || "Failed to fetch RAI filters");
        return;
      }

      console.warn("Token expired or request failed, refreshing token...");

      // 🔄 Remove old token
      localStorage.removeItem("raiToken");

      // 🔐 Fetch new token
      const newToken = await loginAndFetchToken();
      if (newToken) {
        localStorage.setItem("raiToken", newToken);
      }

      // 🔁 Retry with fresh token (+1 retry count)
      return fetchFilterData(newToken, retryCount + 1);
    }

    // 🎉 SUCCESS → process data
    const data = result.data.selectedPrediction;

    const findingsFilterOptions = (data.models || []).map(item => ({
      label: item,
      value: item,
    }));

    setFindingsFilterOptions(findingsFilterOptions);
    setFilters({
      manufacturer: data.scanners || [],
      age: data.ageGroup || [],
      gender: data.gender || [],
    });

  } catch (error) {
    console.error("Failed to fetch filter data", error);
    setErrorMessage("Error fetching filter data");
  }
};



  const mapGenderCode = (genderCode) => {
    switch (genderCode?.toUpperCase()) {
      case 'M':
        return 'Male';
      case 'F':
        return 'Female';
      case 'O':
        return 'Others';
      case '-':
      case '':
      case null:
      case undefined:
        return 'Unknown';
      default:
        return 'Unknown';
    }
  };

  const convertDicomAgeToYears = (dicomAge) => {
    if (!dicomAge || dicomAge.length !== 4) return null;

    const num = parseInt(dicomAge.slice(0, 3), 10);
    const unit = dicomAge[3];

    switch (unit) {
      case 'Y':
        return Math.round(num);
      case 'M':
        return Math.round(num / 12);
      case 'W':
        return Math.round(num / 52.143);
      case 'D':
        return Math.round(num / 365.25);
      default:
        return null;
    }
  };

  /**
   * Finds the correct age group for a DICOM age string
   */
  const getAgeGroupFromDicomAge = (dicomAge) => {
    if (!dicomAge) return 'Unknown';

    let ageInYears;

    if (!isNaN(dicomAge)) {
      // Plain number as string (e.g., "45")
      ageInYears = parseInt(dicomAge);
    } else {
      // DICOM format like "045Y", "003M", "100D"
      const unit = dicomAge.slice(-1).toUpperCase();
      const number = parseInt(dicomAge.slice(0, -1));
      if (isNaN(number)) return 'Unknown';

      switch (unit) {
        case 'Y':
          ageInYears = number;
          break;
        case 'M':
          ageInYears = number / 12;
          break;
        case 'D':
          ageInYears = number / 365;
          break;
        default:
          return 'Unknown';
      }
    }

    if (isNaN(ageInYears)) return 'Unknown';

    if (ageInYears <= 15) return '0-15';
    if (ageInYears <= 30) return '15-30';
    if (ageInYears <= 50) return '30-50';
    if (ageInYears <= 70) return '50-70';
    return '70+';
  };


  useEffect(() => {
    if (data === undefined || data === null) {
      return;
    }
    let age = getAgeGroupFromDicomAge(data.patientAge);
    let gender = mapGenderCode(data.patientSex);
    const initialFilters = {
      manufacturer: data.manufacturersModelName || '',
      age: age || '',
      gender: gender || '',
    }

    let inputOrgan = data.organ || '';
    setOrgan(inputOrgan);
    let inputModality = data.modalityName || '';
    setModality(inputModality);
    setSelectedFilters(initialFilters);
  }, [data]);

  useEffect(() => {
    if (findings && findings.length > 0 && findingsFilterOptions.length > 0) {
      const match = findingsFilterOptions.find(option =>
        findings.some(finding => finding.value === option.value)
      );

      if (match) {
        setSelectedFinding(match.value);
      }
    }
  }, [findings, findingsFilterOptions]);

useEffect(() => {
  if (!selectedFinding) return;

  const token = localStorage.getItem("raiToken");
  fetchData(token, selectedFilters, organ, modality);
}, [selectedFinding, selectedFilters, organ, modality]);
  

  const loginAndFetchToken = async () => {
    try {
      const formData = new FormData();
      formData.append("username", "dtadmin");
      formData.append("password", "Dtadmin$0978");

      const res = await fetch(`${getEnv("REACT_APP_RAI_BASE_URL")}api/rai/auth/login`, {
        method: "POST",
        body: formData, // ✅ automatically sets correct Content-Type
      });

      const result = await res.json();

      if (result.success && result.access_token) {
        localStorage.setItem("raiToken", result.access_token);
        localStorage.setItem("raiClientID", result.clientID);
        return result.access_token;
      } else {
        throw new Error(result.message || "RAI login failed");
      }
    } catch (err) {
      console.error("RAI login failed:", err);
      setErrorMessage("RAI login failed");
    }
  };

  const normalizeModality = (modality) => {
  if (!modality) return null;

  const mod = modality.toUpperCase();

  if (mod === "CR" || mod === "DX") return "X-Ray";
  if (mod === "CT") return "CT";
  if (mod === "MG" || mod === "MMG") return "MMG";

  return modality; // fallback
};

const normalizeOrgan = (organ) => {
  if (!organ) return null;

  const o = organ.toUpperCase();

  if (["CHEST", "BREAST", "BRAIN"].includes(o)) return o;

  return organ; // fallback or return null
};


  const fetchData = async (token, selectedFilters, organ, modality) => {
  try {
    const raiToken = token || localStorage.getItem("raiToken");
    const clientID = localStorage.getItem("raiClientID");
    const today = new Date().toISOString().split("T")[0];

    const normalizedModality = normalizeModality(modality);
    const normalizedOrgan = normalizeOrgan(organ);

    // Base filters common to all queries
    const baseFilters = {
      finding: [selectedFinding],
      modelDeveloper: ["Deeptek"],
      site: ["CGH"],
      organ: [normalizedOrgan],
      modality: [normalizedModality],
      period: ["2020-01-01", today],
    };

    const pct = (v) =>
      typeof v === "number" ? `${(v * 100).toFixed(1)}%` : "NA";

    const getMetrics = async (filtersPayload) => {
      const response = await fetch(
        `${getEnv("REACT_APP_RAI_BASE_URL")}api/rai/model-performance`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${raiToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            clientID,
            projectID: "473686",
            groundTruth: "radiologist",
            prediction: "ai",
            filters: filtersPayload,
          }),
        }
      );

      const result = await response.json();

      const vendor = result.data?.vendors?.Deeptek
        ?? Object.values(result.data?.vendors || {})[0];

      if (result.success && vendor?.performanceMetrics) {
        const { Sensitivity, Specificity, AUROC, NPV } = vendor.performanceMetrics;
        return {
          sensitivity: pct(Sensitivity),
          specificity: pct(Specificity),
          precision: pct(NPV),
          auroc: pct(AUROC),
        };
      }

      return null;
    };

    // EXTRACT SELECTED VALUES
    const selAge = selectedFilters.age || null;
    const selGender = selectedFilters.gender || null;
    const selManu = selectedFilters.manufacturer || null;

    // EXTRACT AVAILABLE FILTER VALUES (this is your `filters.*`)
    const allAges = filters.age || [];
    const allGenders = filters.gender || [];
    const allManufacturers = filters.manufacturer || [];

    // 🎯 Make the 4 API calls in parallel
    const [
      overallMetrics,
      ageMetrics,
      genderMetrics,
      manufacturerMetrics,
    ] = await Promise.all([
      // 1️⃣ OVERALL METRICS (use selected filters)
      getMetrics({
        ...baseFilters,
        ageGroup: selAge ? [selAge] : allAges,
        patientGender: selGender ? [selGender] : allGenders,
        manufacturerModelName: selManu ? [selManu] : allManufacturers,
      }),

      // 2️⃣ AGE METRICS (age fixed by selectedFilters; others widened)
      getMetrics({
        ...baseFilters,
        ageGroup: selAge ? [selAge] : [],
        patientGender: allGenders, // ⬅ important difference
        manufacturerModelName: allManufacturers,
      }),

      // 3️⃣ GENDER METRICS
      getMetrics({
        ...baseFilters,
        ageGroup: allAges,
        patientGender: selGender ? [selGender] : [],
        manufacturerModelName: allManufacturers,
      }),

      // 4️⃣ MANUFACTURER METRICS
      getMetrics({
        ...baseFilters,
        ageGroup: allAges,
        patientGender: allGenders,
        manufacturerModelName: selManu ? [selManu] : [],
      }),
    ]);

    // 🧩 Build the final table
    const metricsMatrix = {
      sensitivity: {
        overall: overallMetrics?.sensitivity || "NA",
        manufacturer: manufacturerMetrics?.sensitivity || "NA",
        age: ageMetrics?.sensitivity || "NA",
        gender: genderMetrics?.sensitivity || "NA",
      },
      specificity: {
        overall: overallMetrics?.specificity || "NA",
        manufacturer: manufacturerMetrics?.specificity || "NA",
        age: ageMetrics?.specificity || "NA",
        gender: genderMetrics?.specificity || "NA",
      },
      auroc: {
        overall: overallMetrics?.auroc || "NA",
        manufacturer: manufacturerMetrics?.auroc || "NA",
        age: ageMetrics?.auroc || "NA",
        gender: genderMetrics?.auroc || "NA",
      },
      precision: {
        overall: overallMetrics?.precision || "NA",
        manufacturer: manufacturerMetrics?.precision || "NA",
        age: ageMetrics?.precision || "NA",
        gender: genderMetrics?.precision || "NA",
      },
    };

    setPerformanceMatrix(metricsMatrix);
  } catch (error) {
    console.error("Failed to fetch model performance data", error);
    setErrorMessage("Failed to fetch model performance data");
  }
};



  useEffect(() => {
    const ensureToken = async () => {
      let token = localStorage.getItem("raiToken");
      if (!token) {
        token = await loginAndFetchToken();
      }
      if (token) {
        fetchFilterData(token);
      }
    };
    ensureToken();
  }, []);


  const renderColumnFilter = column => {
    const selectOptions = [
      { label: t('rai_performance_matrix.' + column), value: "" },
      ...filters[column].map(option => ({ label: option, value: option }))
    ];
    return (
      <div>
        <Select
          options={selectOptions}
          value={selectedFilters[column] !== '' ?
            { label: selectedFilters[column], value: selectedFilters[column] } : null}
          onChange={option => {
            let isFilterChanged = selectedFilters[column] !== option.value;
            setFilterChangeStatus(prev => ({ ...prev, [column]: isFilterChanged }));
            setSelectedFilters(prev => ({ ...prev, [column]: option ? option.value : null }));

          }
          }
          placeholder={t('rai_performance_matrix.' + column)}
          styles={columnFilterStyles}
          formatOptionLabel={formatColumnOptionLabel}
          components={{ columnSingleValue, DropdownIndicator: columnDropdownIndicator }}
          isSearchable={false}
        />
      </div>
    )
  };

  const cellStyle = { border: '2px groove rgba(255, 255, 255, 0.15)', padding: '5px' };

  const SingleValue = ({ data, ...props }) => (
    <components.SingleValue {...props}>
      Findings: {data.label}
    </components.SingleValue>
  );

  const columnSingleValue = (props) => (
    <components.SingleValue {...props}>
      <div
        title={props.data.label}
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '100%',
          fontSize: '9px',
          fontWeight: '400',
          margin: 0,
          padding: 0,
          maxWidth: '38px',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          color: '#F5F5F5',
          // width: '100%',
          lineHeight: 'normal',
        }}
      >
        {props.data.label}
      </div>
    </components.SingleValue>
  );



  return (
    <>
      <OpenWidgetHeader
        options={findingsFilterOptions}
        selectedValue={selectedFinding}
        onChangeValue={setSelectedFinding}
        SelectStyles={WidgetSelectStyles}
        SingleValueComponent={SingleValue}
        rightIcons={[
          { key: 'open', onClick: () => handleOpenRAIWindow1(studyId, firmId, userName, false, false, false, true, ""), Icon: OpenInNewIcon },
          { key: 'close', onClick: () => setShowRAIPanel(false), Icon: DownArrowIcon },
        ]}
      />
      <div style={{ padding: '0 10px 4px 10px', marginBottom: '8px', height: '100%', display: 'flex', alignItems: 'center' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', padding: '0' }}>
          <thead>
            <tr style={{ height: '33px' }}>
              <th style={{ padding: '5px 0', width: '24%', textAlign: 'left' }}>

              </th>
              <th style={{ padding: '5px 0', width: '19%', textAlign: 'center' }}>
                <div style={{ fontWeight: '700', fontSize: '12px', lineHeight: '14px', color: '#F5F5F5' }}>{t('rai_performance_matrix.overall')}</div>
              </th>
              {Object.keys(filters).map(column => (
                <th key={column} style={{ padding: '5px 0', width: '19%' }}>
                  {renderColumnFilter(column)}
                </th>
              ))}
            </tr>
          </thead>

          <tbody >
            {Object.entries(performanceMatrix).map(([rowKey, rowData]) => (
              <tr key={rowKey} style={{ height: '38px' }}>
                <td style={{ ...cellStyle, fontWeight: '700', fontSize: '12px', lineHeight: '16px', color: '#FFFFFF' }}>
                  {t('rai_performance_matrix.' + rowKey)}
                </td>
                {Object.keys(rowData).map(column => (
                  <td key={column} style={{ ...cellStyle, paddingLeft: '10px', paddingRight: '10px', textAlign: 'right', fontWeight: '300', fontSize: '12px', lineHeight: '20px', color: '#FFFFFF' }}>
                    {rowData[column]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* <div style={{display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "right", marginRight:"10px"}}>
      <AugmentoIcon></AugmentoIcon>
    </div> */}

      {/* <div style={{ position: "relative", height: "38px", backgroundColor: "#0C1A2C", zIndex: 1000   }}>
        <div
          style={{
            position: "absolute",
            right: 10,
            paddingTop: "7px",
            // display: "flex",
            // flexDirection: "row",
            // alignItems: "center",
          }}
        >
        <AugmentoIcon />
      </div>
    </div> */}
    </>
  );
};

export default RAIPerformanceResults;
